import { BodyText } from '@lessonnine/design-system.lib'
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json'
import React from 'react'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
// context and data
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown'
import BackButton from 'src/viewLayer/components/pages/BackButton'
import CardLayout from 'src/viewLayer/components/pages/CardLayout'
import SignupLink from 'src/viewLayer/components/shared/HintLinks/SignupLink'
// view components
import EmailInput from 'src/viewLayer/components/shared/Inputs/EmailInput'
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton'
import { t } from 'src/viewLayer/helpers/translations'

import EmailImage from './Email.svg'
import {
  ActionsContainer,
  FormContainer,
  InputFrame,
  LoginEmailPageContainer,
} from './index.styled'
import ZendeskWidget from './ZendeskWidget'

export default function LoginEmailPage({
  appType,
  email,
  errorKey,
  inProgress,
  isFocused,
  onChange,
  onReset,
  onSubmit,
  path,
}) {
  useTrackPageShown({ appType, pageType: path })
  const { locale, queryParams } = useRouteParamsContext()
  // if the user is viewing the page in German and came from a link to cancel
  const userWantsToCancelSubscription = locale === 'de' && queryParams.get('cancel')
  const pageTitleKey = userWantsToCancelSubscription ? 'email.cancel.title' : 'email.title'

  const apiError = queryParams.get('error_code')
  const errorMessages = {
    account_issue: t('login.b2b.error.idp_other_error'),
    authentication_failed: t('login.b2b.error.idp_no_access'),
    magic_link_invalid: t('login.magic_link.error_message'),
  }
  const renderApiError = (errorCode) => errorMessages[errorCode] || null

  return (
    <LoginEmailPageContainer align="leading" alignItems="center">
      <CardLayout
        appType={appType}
        hideTermsAndConditions={userWantsToCancelSubscription}
        Image={EmailImage}
        title={t(pageTitleKey)}
      >
        {!userWantsToCancelSubscription && <SignupLink />}
        <BackButton path={path} trackingId="backbutton-webview-dismiss" />
        <FormContainer>
          <form onSubmit={onSubmit}>
            <InputFrame>
              <EmailInput
                clearValue={onReset}
                disabled={inProgress}
                errorKey={errorKey}
                isFocused={isFocused}
                onChangeHandler={onChange}
                value={email}
              />
            </InputFrame>
            {Object.prototype.hasOwnProperty.call(errorMessages, apiError) && (
              <BodyText
                as="p"
                color={tokens.color.theme.dark.reference.red.red60}
                size="small"
                textAlign="center"
              >
                {renderApiError(apiError)}
              </BodyText>
            )}
          </form>
          <ActionsContainer>
            <TrackableButton
              disabled={email.length === 0 || inProgress}
              fullWidth={true}
              id="uat-continue-button"
              inProgress={inProgress}
              onClick={onSubmit}
              title="Continue button"
              trackingId="email_continue"
              variant="primary"
            >
              {t('email.button.continue')}
            </TrackableButton>
          </ActionsContainer>
        </FormContainer>
      </CardLayout>
      <ZendeskWidget />
    </LoginEmailPageContainer>
  )
}
